import { EXPERIMENT_ID, TYPE } from '../Core.constants';

const getSuperProps = ({ store = {}, engineVersion } = {}) => {
  const {
    config = {},
    components = {},
    club = {},
    finder: { place: { id: [placeHotelId] = [], isHotel } = {} } = {},
    hotel: { features = {}, ...hotel } = {},
    id,
    type,
    urlParams = {},
    variant,
  } = store;
  const { tracking = {} } = config;
  const hotelId = isHotel ? placeHotelId : hotel.id;
  const { country = {}, name, showMiraiTwin } = features[hotelId] || {};
  const { name: chainName } = features[id] || {};

  const props = {
    chain_id: type === TYPE.CHAIN ? `${id}` : 'independent',
    chain_name: type === TYPE.CHAIN ? chainName : undefined,
    engine_version: engineVersion,
    feature_3d: showMiraiTwin,
    feature_loyalty: !!club?.active,
    feature_price_comp: !!tracking?.compareTracking?.length,
    feature_sarai: !!components.chat,
    hotel_country: country.en,
    hotel_id: hotelId,
    hotel_name: name,
    is_internal_user: urlParams.internalUser === 'true',
    [EXPERIMENT_ID]: EXPERIMENT_ID ? variant : undefined,
    active_experiments: EXPERIMENT_ID && variant ? { [EXPERIMENT_ID]: variant } : undefined,
  };

  return Object.fromEntries(Object.entries(props).filter(([, value]) => value !== undefined && value !== ''));
};

export { getSuperProps };
